import type { Unsubscribe } from '@/rules-management/domain/Unsubscribe.ts';

export class RuleExtractionId {
  readonly #value: string;

  private constructor(value: string) {
    this.#value = value;
  }

  static of(value: RuleExtractionId | string): RuleExtractionId {
    if (value instanceof RuleExtractionId) {
      return value;
    }
    return new RuleExtractionId(value);
  }

  get value(): string {
    return this.#value;
  }
}

export class RuleExtractionInProgress {
  readonly #id: RuleExtractionId;

  private constructor(id: RuleExtractionId) {
    this.#id = id;
  }

  static of(id: RuleExtractionId): RuleExtractionInProgress {
    return new RuleExtractionInProgress(id);
  }

  get id(): RuleExtractionId {
    return this.#id;
  }
}

export class RuleExtractionCompleted {
  readonly #id: RuleExtractionId;

  private constructor(id: RuleExtractionId) {
    this.#id = id;
  }

  static of(id: RuleExtractionId): RuleExtractionCompleted {
    return new RuleExtractionCompleted(id);
  }

  get id(): RuleExtractionId {
    return this.#id;
  }
}

export class RuleExtractionFailed {
  readonly #id: RuleExtractionId;
  readonly #error: Error;

  private constructor(id: RuleExtractionId, error: Error) {
    this.#id = id;
    this.#error = error;
  }

  static of(id: RuleExtractionId, error: Error): RuleExtractionFailed {
    return new RuleExtractionFailed(id, error);
  }

  get id(): RuleExtractionId {
    return this.#id;
  }

  get error(): Error {
    return this.#error;
  }
}

export type RuleExtraction =
  RuleExtractionInProgress | RuleExtractionCompleted | RuleExtractionFailed;

type OnExtractionChange = (extraction: RuleExtraction) => void;

export type ListenExtraction = (onChange: OnExtractionChange) => Unsubscribe;
